import { createTheme } from '@mui/material/styles';

const fontFamily = '"Titillium Web", "Roboto", "Helvetica", "Arial", sans-serif';
const headingFamily = '"Orbitron", "Titillium Web", sans-serif';

const theme = createTheme({
  typography: {
    fontFamily,
    fontWeightRegular: 500,
    body1: { fontWeight: 500 },
    body2: { fontWeight: 500 },
    h1: { fontFamily: headingFamily, fontWeight: 700, letterSpacing: '0.05em' },
    h2: { fontFamily: headingFamily, fontWeight: 700, letterSpacing: '0.04em' },
    h3: { fontFamily: headingFamily, fontWeight: 700, letterSpacing: '0.03em' },
    h4: { fontFamily: headingFamily, fontWeight: 500, letterSpacing: '0.02em' },
    h5: { fontFamily: headingFamily, fontWeight: 500, letterSpacing: '0.02em' },
    h6: { fontFamily: headingFamily, fontWeight: 500, letterSpacing: '0.01em' },
    subtitle1: { fontFamily, fontWeight: 600 },
    subtitle2: { fontFamily, fontWeight: 600 },
    button: { fontFamily: headingFamily, fontWeight: 500, letterSpacing: '0.08em', textTransform: 'uppercase' },
  },
  palette: {
    primary: {
      main: '#388E3C',
      light: '#6abf69',
      dark: '#00600f',
      contrastText: '#000000',
    },
    secondary: {
      main: '#4a148c',
      light: '#7c43bd',
      dark: '#12005e',
      contrastText: '#ffffff',
    },
    background: {
      paper: '#a8d48a',
    },
    divider: '#000000',
  },
  components: {
    MuiAvatar: {
      styleOverrides: {
        img: {
          backgroundColor: '#ffffff',
        },
      },
    },
    MuiCardMedia: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
        },
      },
    },
  },
});

export default theme;
